// services/taloes.js
import axiosInstance from './axiosInstance';

const TALOES_API_URL = '/taloes';

const taloesService = {
  // Obter talão anulado por ID e parâmetros de pesquisa
  async getAnuladoById(idempresa, searchParams) {
    try {
      const params = new URLSearchParams(searchParams);
      const response = await axiosInstance.get(
        `${TALOES_API_URL}/anulado/getById.php?idempresa=${idempresa}&${params}`
      );
      
      if (response.data && !response.data.error && Object.keys(response.data).length > 0) {
        // Converter string 't' para boolean
        response.data.anulado = response.data.anulado === "t";
        return response.data;
      }
      
      return null;
    } catch (error) {
      console.error('Erro ao obter talão anulado:', error);
      throw error;
    }
  },

  // Definir estado de anulação do talão
  async setAnulado(talaoData) {
    try {
      const response = await axiosInstance.post(
        `${TALOES_API_URL}/anulado/set.php`,
        talaoData
      );
      return response.data;
    } catch (error) {
      console.error('Erro ao definir estado de anulação:', error);
      throw error;
    }
  }
};

export default taloesService;
